// extracted by mini-css-extract-plugin
export default {"know_more__text":"know_more_know_more__text__9QJqH","animationInOut":"know_more_animationInOut__6L9iF","zoomInZoomOut":"know_more_zoomInZoomOut__xd2Mm"};